import { render, staticRenderFns } from "./401.vue?vue&type=template&id=6ae67890&scoped=true&"
import script from "./401.vue?vue&type=script&lang=ts&"
export * from "./401.vue?vue&type=script&lang=ts&"
import style0 from "./401.vue?vue&type=style&index=0&id=6ae67890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae67890",
  null
  
)

export default component.exports